package com.example.mystybag.appCore.logic

import com.arkivanov.decompose.ExperimentalDecomposeApi
import com.arkivanov.decompose.router.children.ChildNavState
import com.arkivanov.decompose.router.pages.ChildPages
import com.arkivanov.decompose.router.pages.Pages
import com.arkivanov.decompose.router.pages.PagesNavigation
import com.arkivanov.decompose.router.pages.select
import com.arkivanov.decompose.router.pages.selectFirst
import com.arkivanov.decompose.value.Value
import com.example.mystybag.common.resources.SR
import com.example.mystybag.commonData.expected.getOS
import com.example.mystybag.commonData.helpers.PlatformDefines.IOS
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_APP_REVIEW_DIALOG_SHOWN_TIMES
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_LOGIN_TIMES_FOR_MORE_THAN_5_SEC
import com.example.mystybag.core.expected.Connection.removeInternetConnectionListener
import com.example.mystybag.core.expected.Preferences.getInt
import com.example.mystybag.core.expected.Preferences.setInt
import com.example.mystybag.core.expected.openAppStorePage
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.safeCast
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.BaseViewModel
import com.example.mystybag.core.logic.base.BottomSheetChild
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.EmptyViewModel
import com.example.mystybag.core.logic.base.NavigatorConfig
import com.example.mystybag.core.logic.base.ScrollToTopInterface
import com.example.mystybag.core.logic.base.UIBottomSheetConfig
import com.example.mystybag.core.logic.base.UploadDocumentCallbacks
import com.example.mystybag.core.logic.base.appChildPages
import com.example.mystybag.core.logic.base.firstPage
import com.example.mystybag.common.logic.BSNavigationFilterResults
import com.example.mystybag.common.logic.BSNavigationRateApp
import com.example.mystybag.common.logic.DialogNavigatorStandard
import com.example.mystybag.common.logic.RateAppBottomSheetChild
import com.example.mystybag.common.model.MainUIState
import com.example.mystybag.appCore.helpers.NotificationDataHandler
import com.example.mystybag.appCore.helpers.initialData.InitialDataResult
import com.example.mystybag.notificationsUtils.model.BaseMessageModel
import com.example.mystybag.appCore.logic.pages.DeliveryPageViewModel
import com.example.mystybag.appCore.logic.pages.FavoritesPageViewModel
import com.example.mystybag.appCore.logic.pages.HomePageCallbacks
import com.example.mystybag.appCore.logic.pages.HomePageViewModel
import com.example.mystybag.appCore.logic.pages.FilterResultsBottomSheetViewModel
import com.example.mystybag.appCore.logic.pages.ProfilePageViewModel
import com.example.mystybag.appCore.logic.pages.DashboardViewModel
import com.example.mystybag.appCore.logic.pages.BagsViewModel
import com.example.mystybag.appCore.logic.pages.MerchantLocationsListViewModel
import com.example.mystybag.appCore.logic.pages.MenuViewModel
import com.example.mystybag.communication.Communication
import com.example.mystybag.appCore.helpers.PushTokenServerSync
import com.example.mystybag.communication.common.CommonCommands.getAllBags
import com.example.mystybag.communication.common.CommonCommands.sendUserLogin
import com.example.mystybag.communication.utils.Response
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.login.logic.NavigatorFeatureLoginAndRegistration
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel
import com.example.mystybag.sharedmodels.project.responseModels.toHomeTopPickUiModel
import com.example.mystybag.sharedmodels.project.requestModels.LoginUserRequestModel
import kotlinx.collections.immutable.toImmutableList
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_CODE
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_JWT
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_MERCHANT_JWT
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_DELETE_ACCOUNT_REQUEST_PENDING
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_PUSH
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_PUSH
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.helpers.GlobalCommonData
import com.example.mystybag.database.communication.db.DatabaseProvider
import com.example.mystybag.sharedmodels.project.requestModels.GetAllBagsRequestModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

@OptIn(ExperimentalDecomposeApi::class)
class MainViewModel(context: AppContext): ChildViewModel<MainUIState>(context, MainUIState()),
    UploadDocumentCallbacks,
    HomePageCallbacks
{
    private val pageNavigation                          = PagesNavigation<NavigatorConfig>()
    private var initialDataResult : InitialDataResult?  = null

    val pages: Value<ChildPages<*, BaseViewModel>> = context.appChildPages(
        source          = pageNavigation,
        navigation      = context.navigation,
        initialPages    = { 
            val merchantJwt = Preferences.getString(key = PREFERENCES_MERCHANT_JWT, "")
            val isMerchant = merchantJwt.isNotEmpty()
            
            if (isMerchant) {
                // Merchant tabs
                Pages(
                    items = listOf(
                        NavigatorPageDashboard,
                        NavigatorPageBags,
                        NavigatorPageLocations,
                        NavigatorPageMenu
                    ),
                    selectedIndex = 0
                )
            } else {
                // Client tabs
                Pages(
                    items = listOf(
                        NavigatorPageHome,
                        NavigatorPageDelivery,
                        NavigatorPageFavorites,
                        NavigatorPageProfile
                    ),
                    selectedIndex = 0
                )
            }
        },
        callbacks = {
            when (it) {
                NavigatorPageHome       -> this
                NavigatorPageFavorites  -> this
                NavigatorPageDashboard  -> this
                else                    -> context.callbacks
            }
        },
        progressListener = {
            when (it) {
                is NavigatorPageHome -> progressListener
                else                     -> null
            }
        },
        handleBackButton = true,
        pageStatus = { index, pages ->
            when (index) {
                pages.selectedIndex -> ChildNavState.Status.RESUMED
                else                -> ChildNavState.Status.CREATED
            }
        }
    ) { config, componentContext ->
        when (config) {
            // Client pages
            is NavigatorPageHome        -> HomePageViewModel(componentContext)
            is NavigatorPageDelivery   -> DeliveryPageViewModel(componentContext)
            is NavigatorPageFavorites  -> FavoritesPageViewModel(componentContext)
            is NavigatorPageProfile    -> ProfilePageViewModel(componentContext)
            // Merchant pages
            is NavigatorPageDashboard  -> DashboardViewModel(componentContext)
            is NavigatorPageBags       -> BagsViewModel(componentContext)
            is NavigatorPageLocations -> MerchantLocationsListViewModel(componentContext)
            is NavigatorPageMenu        -> MenuViewModel(componentContext)
            else                        -> EmptyViewModel(componentContext)
        }
    }

    override fun onResume() {
        if (getOS() == IOS)
            checkForInitialData(true)
    }

    override fun onBackButtonClicked() {
        val merchantJwt = Preferences.getString(key = PREFERENCES_MERCHANT_JWT, "")
        val isMerchant = merchantJwt.isNotEmpty()
        
        if (pages.value.selectedIndex == 0)
            launchOnMain {
                showDialog(
                    DialogNavigatorStandard(
                        title           = sharedString(SR.strings.log_out),
                        message         = sharedString(SR.strings.are_you_sure_you_want_to_proceed),
                        positiveTitle   = sharedString(SR.strings.log_out_yes),
                        negativeTitle   = sharedString(SR.strings.cancel),
                        stackedButtons  = true
                    )
                ).onPositiveClick {
                    Communication.token = ""
                    Preferences.clear()
                    CoroutineScope(Dispatchers.Default).launch {
                        DatabaseProvider.clearDatabase()
                    }
                    super.onBackButtonClicked()
                }
            }
        else
            pageNavigation.selectFirst { _, _ ->
                if (isMerchant) {
                    pages.firstPage<DashboardViewModel>()?.scrollToTop()
                } else {
                    pages.firstPage<HomePageViewModel>()?.scrollToTop()
                }
            }
    }

    override fun configureBottomSheets(config: UIBottomSheetConfig, context: AppContext): BottomSheetChild {
        return when (config) {
            is BSNavigationRateApp -> RateAppBottomSheetChild(
                onLaterClicked  = {
                    closeBottomSheet()
                },
                onRateUsClicked = {
                    openAppStorePage()
                    closeBottomSheet()
                }
            )

            is BSNavigationFilterResults -> FilterResultsBottomSheetChild(
                viewModel = FilterResultsBottomSheetViewModel(
                    context = context,
                    onClose = { closeBottomSheet() },
                    onApply = { filterState ->
                        pages.firstPage<HomePageViewModel>()?.applyLocalFilters(filterState)
                    },
                    initialFilter = pages.firstPage<HomePageViewModel>()?.getAppliedFilter(),
                    availableLocations = pages.firstPage<HomePageViewModel>()?.getAvailableLocationsForFilter() ?: emptyList()
                )
            )

            else -> super.configureBottomSheets(config, context)
        }
    }

    /** Текущият списък с торби от таб Начало (за проверки извън Home страницата). */
    fun getHomeCatalogBagsFlattened(): List<HomeTopPickUiModel> {
        return pages.value.items
            .find { it.instance is HomePageViewModel }
            ?.instance
            ?.safeCast<HomePageViewModel>()
            ?.getAllCatalogBagsFlattened()
            ?: emptyList()
    }

    fun selectPage(index: Int, scrollToTop: Boolean = false, fromView: Boolean = false, onPageSelected: (() -> Unit)? = null) {
        if (!fromView)
            closeBottomSheet()

        fun refreshSelectedPage(selectedIndex: Int) {
            // Ensure merchant Bags tab always fetches on selection.
            // Relying only on onResume() is not enough with Decompose Pages.
            pages.value.items.getOrNull(selectedIndex)?.instance
                ?.safeCast<BagsViewModel>()
                ?.loadBagsData()
            // Ensure merchant Locations tab is refreshed when selected (e.g. after adding a location).
            pages.value.items.getOrNull(selectedIndex)?.instance
                ?.safeCast<MerchantLocationsListViewModel>()
                ?.loadLocations()
        }

        if (pages.value.selectedIndex != index) {
            pageNavigation.select(index = index) { _, _ ->
                if (scrollToTop)
                    pages.value.items[pages.value.selectedIndex].instance.safeCast<ScrollToTopInterface>()?.scrollToTop()
                refreshSelectedPage(index)
                onPageSelected?.invoke()
            }
        }
        else {
            if (scrollToTop)
                pages.value.items[pages.value.selectedIndex].instance.safeCast<ScrollToTopInterface>()?.scrollToTop()
            refreshSelectedPage(index)
            onPageSelected?.invoke()
        }
    }

    override fun parentCloseBottomSheet() {
        closeBottomSheet()
    }

    override fun parentOpenBottomSheet(config: UIBottomSheetConfig) {
        openBottomSheet(config)
    }



    override fun onCreate() {
        overrideBackButton              = true
        navControls.isVisible           = false
        navControls.backButtonVisible   = false
        
        // Проверяваме дали има нужда от login (при успех се извиква getAllBagsCommand() за първия таб)
        val mail = Preferences.getString(key = PREFERENCES_EMAIL, "")
        val code = Preferences.getString(key = PREFERENCES_CODE, "")
        
        if (mail.isNotEmpty() && code.isNotEmpty() && Communication.token.isEmpty()) {
            sendLoginCommand(mail, code)
        }

        if (Communication.token.isNotEmpty()) {
            sendUpdatePushTokenCommand()
        }

        /*shortcutProvider    = ShortcutUpdater
        shortcutProvider?.createShortcutsIfNeeded()

        if (!isLoginSuccess)
            AppViewModel.showOfflineViewBottomSheet()

        setupListeners()
        checkForInitialData(false)

        val currentVersion  = getVersion()
        val previousVersion = getString(PREFERENCES_ICARD_APP_VERSION, "0")*/
    }
    
    /**
     * Извършва login и след успешен login зарежда торбите
     */
    private fun sendLoginCommand(mail: String, code: String) {
        commandBlock {
            sendUserLogin(
                request = LoginUserRequestModel(
                    mail = mail,
                    code = code
                )
            )
                .onResponse(
                    success = { response ->
                        Communication.token = response.token


                        Preferences.setString(PREFERENCES_JWT, response.token)
                        Preferences.setString(PREFERENCES_MERCHANT_JWT, "")

                        val emailToStore = if (response.email.isNotEmpty()) response.email else mail
                        Preferences.setString(PREFERENCES_EMAIL, emailToStore)
                        GlobalCommonData.setEmailValue(emailToStore)

                        GlobalCommonData.setUserIdValue(response.userId)
                        GlobalCommonData.setFirstNameValue(response.firstName)
                        GlobalCommonData.setLastNameValue(response.lastName)
                        GlobalCommonData.setUserImgUrlValue(response.userImgUrl)
                        GlobalCommonData.setDialCodeValue(response.dialCode)
                        GlobalCommonData.setPhoneNumberValue(response.phoneNumber)
                        GlobalCommonData.setNumberOfReservationsValue(response.numberOfReservations)
                        GlobalCommonData.setSavedAmountValue(response.savedAmount)
                        GlobalCommonData.setCityId(response.cityId)

                        Preferences.setBoolean(PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_PUSH, response.reservationCompletedPushEnabled)
                        Preferences.setBoolean(PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_EMAIL, response.reservationCompletedEmailEnabled)
                        Preferences.setBoolean(PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_PUSH, response.discountsAndNewsPushEnabled)
                        Preferences.setBoolean(PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_EMAIL, response.discountsAndNewsEmailEnabled)
                        Preferences.setBoolean(PREFERENCES_DELETE_ACCOUNT_REQUEST_PENDING, response.hasPendingDeleteAccountRequest)
                        
                        // След успешен login, зареждаме торбите
                        getAllBagsCommand()

                        sendUpdatePushTokenCommand()

                        // Request parent to replace MainViewModel to reload pages with correct tabs
                        // This will recreate MainViewModel with client tabs instead of merchant tabs
                        setResult<com.example.mystybag.core.logic.base.MainCallback> {
                            // Navigate back to MainViewModel which will reload with correct pages
                            popToMainAndNavigate(NavigatorMain)
                        }
                    },
                    error = { response ->
                        Communication.token = ""
                        Preferences.clear()
                        CoroutineScope(Dispatchers.Default).launch {
                            DatabaseProvider.clearDatabase()
                        }
                        showSnackbar(Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                        setResult<MainCallback> {
                            popToMainAndNavigate(NavigatorFeatureLoginAndRegistration())
                        }
                    }
                )
        }
    }
    
    /**
     * Зарежда всички торби от API и ги предава към ViewModel-ите
     */
    private fun getAllBagsCommand(onComplete: (() -> Unit)? = null) {
        commandBlock(showProgress = false, hideProgress = false) {
            getAllBags(
                  GetAllBagsRequestModel(userId = GlobalCommonData.userId, clientTimeZoneId = "Europe/Sofia")
            )
                .onResponse(
                    success = { response ->
                        launchOnMain {
                            // Предаваме данните към HomePageViewModel
                            pages.firstPage<HomePageViewModel>()?.loadBagsData(response.list)

                            // Филтрираме само любимите и предаваме към FavoritesPageViewModel
                            val allFavorites = response.list.allBags
                                .filter { it.isFavorite }
                                .map { it.toHomeTopPickUiModel() }
                            // Премахваме дубликати по bagId (id)
                            val uniqueFavorites = allFavorites.distinctBy { it.id }
                            pages.value.items.find { it.instance is FavoritesPageViewModel }
                                ?.instance
                                ?.safeCast<FavoritesPageViewModel>()
                                ?.loadFavoritesData(uniqueFavorites.toImmutableList())
                            onComplete?.invoke()
                        }
                    },
                    error = { response ->
                        launchOnMain { onComplete?.invoke() }
                    },
                    baseError = { _ ->
                        launchOnMain { onComplete?.invoke() }
                    }
                )
        }
    }

    override fun onDestroy() {
        removeInternetConnectionListener()
    }

    private fun setupListeners() { }

    private fun sendUpdatePushTokenCommand() {
        commandBlock(showProgress = false, hideProgress = false) {
            PushTokenServerSync.syncCurrentDevicePushToken()
        }
    }

    fun checkForInitialData(navigateAfterCheck: Boolean) {
        /*if (getIdentificationStatus() != IDENTIFICATION_STATUS_NOT_EEA)
            scope.launch {
                (initialDataResult ?: NotificationDataHandler.getInitialDataResult() ?: DeepLinkDataHandler.getInitialDataResult() ?: ShortcutDataHandler.getInitialDataResult())?.let { data ->
                    if (internetConnectionAvailable)
                        launchOnMain { updateState { it.copy(showInitialDataProgress = true) } }

                    if (navigateAfterCheck && internetConnectionAvailable && isLoginSuccess && !getHasToLogOutDueToInactivity())
                        navigateFromInitialData(data)
                    else
                        initialDataResult = data
                }
            }*/
    }

    private fun navigateFromInitialData(data: InitialDataResult) {
        /*launchOnMain {
            when(data) {
                is InitialDataResult.InitialNavigator                   -> if (isViewEnabled(data.navigator)) { setResult<MainCallback> { popToMainAndNavigate(data.navigator) } }
                is InitialDataResult.InitialPage                        -> {
                    setResult<MainCallback> { popToMainAndNavigate() }
                    selectPage(data.page)
                }
                InitialDataResult.InitialRenewAppBottomSheet            -> {
                    setResult<MainCallback> { popToMainAndNavigate() }
                    showRateAppIfNeeded(true)
                }
                InitialDataResult.InitialFullTariff                     -> sendGetFullTariffDocument()
                InitialDataResult.InitialTaxesDialog                    -> {
                    setResult<MainCallback> { popToMainAndNavigate() }
                    updateState { it.copy(showTaxesDialog = true) }
                }
                InitialDataResult.InitialSupportChat                    -> { openSupportChat() }
                is InitialDataResult.InitialCardBottomSheet             -> data.cardId.toLongOrNull()?.let { id -> checkCardIdToPutOutOnBottomSheet(id) }
                InitialDataResult.InitialEmailConfirmationBottomSheet   -> {
                    setResult<MainCallback> { popToMainAndNavigate() }
                    parentOpenBottomSheet(BSNavigatorEmailConfirmation)
                }
                InitialDataResult.InitialGoToAddMoneyStoredCard         -> goToAddMoneyStoredCard()
                is InitialDataResult.InitialRenewCard                   -> data.cardId.toLongOrNull()?.let { id -> renewCard(id) }
                is InitialDataResult.InitialGoToBankTransfer            -> { setResult<MainCallback> { goToSendBankTransfer() } }
                is InitialDataResult.InitialGoToCardTransfer            -> { setResult<MainCallback> { goToSendCardTransfer() } }
            }
            initialDataResult = null
            updateState { it.copy(showInitialDataProgress = false) }
        }*/
    }


    /*override fun closeView() {
        closeBottomSheet()
    }*/

    private fun showRateAppIfNeeded(withoutCheck: Boolean) {
        if (withoutCheck ||
            getInt(PREFERENCES_APP_REVIEW_DIALOG_SHOWN_TIMES, 0) == 0 && getInt(PREFERENCES_LOGIN_TIMES_FOR_MORE_THAN_5_SEC, 0) >= 5 ||
            getInt(PREFERENCES_APP_REVIEW_DIALOG_SHOWN_TIMES, 0) < 3 && getInt(PREFERENCES_LOGIN_TIMES_FOR_MORE_THAN_5_SEC, 0) >= 3) {
            openBottomSheet(BSNavigationRateApp)

            setInt(PREFERENCES_APP_REVIEW_DIALOG_SHOWN_TIMES, getInt(PREFERENCES_APP_REVIEW_DIALOG_SHOWN_TIMES, 0) + 1)
            setInt(PREFERENCES_LOGIN_TIMES_FOR_MORE_THAN_5_SEC, 0)
        }
    }

    override fun handleBannerClick(type: String) {
        NotificationDataHandler.parseNotificationData(BaseMessageModel(notificationType = type))?.also {
            navigateFromInitialData(it)
        }
    }

    override fun refreshBags(onComplete: (() -> Unit)?) {
        getAllBagsCommand(onComplete)
    }

    override fun removeFavorite(item: HomeTopPickUiModel) {
        pages.value.items.find { it.instance is HomePageViewModel }?.instance?.safeCast<HomePageViewModel>()?.removeFavoriteItem(item)
    }

    override fun onUploadSuccess() {
        TODO("Not yet implemented")
    }

    override fun onUploadFailed() {
        TODO("Not yet implemented")
    }
}